import React, { useEffect } from 'react';

import Select from 'react-select';

import { useFetchData } from '../../infrastructure/hooks/useFetchData';
import type { HubSpotUser } from '../../schemas/HubSpotUserSchema';
import { ApiStatus } from '../../infrastructure/constants/apiStatus';
import * as HubSpotService from '../../services/HubSpotService';

type Props = {
  onSelect: (user: HubSpotUser) => void;
  initialValue?: number | null;
};

const getOptionLabel = (user: HubSpotUser | undefined): string => {
  if (!user) return '';

  return `${user.firstName} ${user.lastName}`;
};
const getOptionValue = (user: HubSpotUser): string => {
  return user.userId.toString();
};

const sortUsers = (users: HubSpotUser[]): HubSpotUser[] => {
  const cloned = structuredClone(users);
  cloned.sort((a, b) => getOptionLabel(a).localeCompare(getOptionLabel(b)))
  return cloned;
}

const HubSpotUserSelector = (props: Props) => {
  const [fetchStatus, hubspotUsers = [], fetchHubSpotUsers] = useFetchData<
    HubSpotUser[]
  >();

  useEffect(() => {
    fetchHubSpotUsers(() => HubSpotService.listUsers());
  }, [fetchHubSpotUsers]);

  const initialValue = hubspotUsers.find(
    user => user.userId === props.initialValue
  );

  const sortedHubspotUsers = sortUsers(hubspotUsers)

  return (
    <Select
      options={sortedHubspotUsers}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      isLoading={fetchStatus === ApiStatus.loading}
      placeholder='Select HubSpot User'
      value={initialValue}
      onChange={value => {
        if (!value) return;
        props.onSelect(value);
      }}
      className='select'
    />
  );
};

export default HubSpotUserSelector;
